import React, { useState, useEffect, useRef } from "react";
import { Row, Col, Breadcrumb, Card, Form, Badge } from "react-bootstrap";

const Contact = () => {
    return (
    <>
        Contact
    </>
  );
};

export default Contact;